import { fork } from 'redux-saga/effects';

import GoldGateway from '~apis/gold';
import ApprovalGateway from '~apis/approval';
import { RootSagaReturnType } from '~types/saga';

import watchGetTransactionListing from './buyAndSellGold/getTransactionListing';
import watchGetGoldPrices from './buyAndSellGold/getGoldPrices';
import watchCreateSellGoldTransaction from './buyAndSellGold/createSellGoldTransaction';
import watchCreateBuyGoldTransaction from './buyAndSellGold/createBuyGoldTransaction';
import watchGetTransactionReceipt from './buyAndSellGold/getTransactionReceipt';
import watchGetInventoryTransactionListing from './goldInventory/getInventoryTransactionListing';
import watchGetInventoryListing from './goldInventory/getInventoryListing';
import watchCreateInventory from './goldInventory/createInventory';
import watchTransferInventory from './goldInventory/transferInventory';
import watchExportInventoryTransactionListing from './goldInventory/exportInventoryTransactionListing';
import watchGetAllProducts from './getAllProducts';
import watchGetAllInventories from './getAllInventories';
import watchGetAllSerialNumbers from './getAllSerialNumbers';
import watchGetBranchInventories from './getBranchInventories';
import watchExportGoldTransactionListing from './goldInventory/exportGoldTransactionListing';
import watchUpdateInventoryTransactionStatus from './goldInventory/updateInventoryTransactionStatus';
import watchUpdateTransactionStatus from './goldInventory/updateTransactionStatus';
import watchGetTotalNetValueOrQuantity from './buyAndSellGold/getTotalNetValueOrQuantity';
import watchCreateTransactionDraft from './buyAndSellGold/createTransactionDraft';
import watchGetTransactionPricePerGramValueAttempt from './buyAndSellGold/getTransactionPricePerGramValue';
import watchGetSerialNumberListing from './serialNumber/getSerialNumberListing';
import watchGetInventoryReceivedListing from './goldInventoryReport/getInventoryReceivedListing';
import watchExportInventoryReceivedListing from './goldInventoryReport/exportInventoryReceivedListing';
import watchGetInventoryDeliveredListing from './goldInventoryReport/getInventoryDeliveredListing';
import watchGetBranchInventoryListing from './goldInventoryReport/getBranchInventoryListing';
import watchExportInventoryDeliveredListing from './goldInventoryReport/exportInventoryDeliveredListing';
import watchCreateGoldConversion from './goldConversion/createGoldConversion';
import watchGetGoldConversionListing from './goldConversion/getGoldConversionListing';
import watchGetGoldConversionAmount from './goldConversion/getGoldConversionAmount';
import watchCreateEarmarkConversion from './earmarkConversion/createEarmarkConversion';
import watchGetEarmarkConversionListing from './earmarkConversion/getEarmarkConversion';
import watchUpdateEarmarkDetails from './earmarkConversion/updateEarmarkDetails';
import watchGetInventoryUsage from './goldInventoryReport/getInventoryUsage';
import watchGetStockOuts from './goldInventory/getStockOutListing';
import watchCreateStockOut from './goldInventory/createStockOut';
import watchGetInventoryStockListing from './goldInventory/getInventoryStockListing';
import watchGetBranchMarketStatus from './buyAndSellGold/getGoldMarketStatus';
import watchGetStockOutsTransactions from './goldInventory/getStockOutTransactionsListing';
import watchGetMultipleSerialNumbers from './getMultipleSerialNumbers';

export default (api: GoldGateway, approvalApi: ApprovalGateway): RootSagaReturnType => {
    function* rootSaga() {
        //buy and sell gold
        yield fork(watchGetTransactionListing, api);
        yield fork(watchGetGoldPrices, api);
        yield fork(watchCreateBuyGoldTransaction, api);
        yield fork(watchCreateSellGoldTransaction, api);
        yield fork(watchCreateTransactionDraft, api);
        yield fork(watchGetTransactionReceipt, api);
        yield fork(watchUpdateTransactionStatus, approvalApi);
        yield fork(watchGetTotalNetValueOrQuantity, api);
        yield fork(watchGetTransactionPricePerGramValueAttempt, api);
        // gold inventory
        yield fork(watchGetInventoryTransactionListing, api);
        yield fork(watchGetInventoryListing, api);
        yield fork(watchCreateInventory, api);
        yield fork(watchTransferInventory, api);
        yield fork(watchExportInventoryTransactionListing, api);
        yield fork(watchExportGoldTransactionListing, api);
        yield fork(watchUpdateInventoryTransactionStatus, approvalApi);
        // gold inventory report
        yield fork(watchGetInventoryReceivedListing, api);
        yield fork(watchExportInventoryReceivedListing, api);
        yield fork(watchGetInventoryDeliveredListing, api);
        yield fork(watchGetBranchInventoryListing, api);
        yield fork(watchExportInventoryDeliveredListing, api);
        // gold conversion
        yield fork(watchCreateGoldConversion, api);
        yield fork(watchGetGoldConversionListing, api);
        yield fork(watchGetGoldConversionAmount, api);
        // Stock Out
        yield fork(watchGetStockOuts, api);
        yield fork(watchCreateStockOut, api);
        yield fork(watchGetInventoryStockListing, api);
        yield fork(watchGetStockOutsTransactions, api);
        //others
        yield fork(watchGetAllProducts, api);
        yield fork(watchGetAllInventories, api);
        yield fork(watchGetAllSerialNumbers, api);
        yield fork(watchGetMultipleSerialNumbers, api);
        yield fork(watchGetSerialNumberListing, api);
        yield fork(watchGetBranchInventories, api);
        yield fork(watchCreateEarmarkConversion, api);
        yield fork(watchGetEarmarkConversionListing, api);
        yield fork(watchUpdateEarmarkDetails, api);
        yield fork(watchGetInventoryUsage, api);
        yield fork(watchGetBranchMarketStatus, api);
    }

    return {
        rootSaga,
    };
};
